import React, { useState, useEffect } from 'react'
import category_card from '../assets/category_card.svg'
import ProgressBar from './ProgressBar'
import { Category } from '@mui/icons-material'
import { Link, useParams, useHistory } from 'react-router-dom'
import CategoryButton from './CategoryButton'
import project_warning from '../assets/project_warning.svg';
import { styled } from '@mui/material/styles';
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';

const BootstrapTooltip = styled(({ className, ...props }) => (
    <Tooltip placement="right" {...props} arrow classes={{ popper: className }} />
))(({ theme }) => ({
    [`& .${tooltipClasses.arrow}`]: {
        color: '#265E85',
    },
    [`& .${tooltipClasses.tooltip}`]: {
        backgroundColor: '#265E85',
    },
}));

function CategoryCard({ category, taskID, categoryName }) {
    const [contracted, setContracted] = useState(0)
    const [forecasted, setForecasted] = useState(0)
    const [spent, setSpent] = useState(0)

    useEffect(() => {
        console.log(category)
        if (category) {
            setSpent(category.Spent)
            setContracted(category.Contracted)
            setForecasted(category.Forecasted)
        }
    }, [])


    const history = useHistory();
    const handleClick = () => {
        history.push({
            pathname: '/budgeting/' + taskID + '/' + categoryName,
        })
    }
    const percent = (a, b) => {
        if (b === 0) return 0
        return Math.round((a / b) * 100)
    }
    const error = category.Spent > category.Forecasted || category.Spent > category.Contracted
    let readings = [
        {
            name: 'Spent',
            value: (forecasted > contracted) ? spent / forecasted * 100 : spent / (contracted) * 100,
            color: '#00A486'
        },
        {
            name: 'Forecasted',
            value: (forecasted > contracted) ? (forecasted - spent) / forecasted * 100 : (forecasted - spent) / (contracted) * 100,
            color: '#BCD4E4'
        }, {
            name: 'Contracted',
            value: (forecasted > contracted) ? 0 : (contracted - forecasted) / contracted * 100,
            color: '#FFFFFF'
        }
    ];
    let readings_error = [
        {
            name: 'error',
            value: 100,
            color: '#D6405B'
        }
    ];
    let readings_upgraded = [
        {
            name: 'Spent',
            value: 99,
            color: '#FFFFFF'
        },
    ]
    return (
        <div className='category-card-container' onClick={() => handleClick()}>
            <div className='category-card-title'>
                <img src={category_card} alt="category" className="category-card" />
                &nbsp; &nbsp;
                {categoryName}
                &nbsp;
                {
                    category.nb_errors > 0 ?
                        <BootstrapTooltip title={category.nb_errors + " imported expenses to link"}>
                            <img src={project_warning} alt='#' />
                        </BootstrapTooltip>
                        : <></>
                }
            </div>
            <div className='category-card-body'>
                <div className='category-card-bar'>
                    <ProgressBar
                        readings={Math.round(forecasted) < Math.round(spent) ? readings_error : forecasted === 0 ? readings_upgraded : readings}
                        width={'200px'} />
                </div>
                <div className='category-card-values'>
                    &nbsp;Contracted: &nbsp;
                    <span className='category-value'>
                        {Math.round(category.Contracted).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                    </span>

                    &nbsp;
                    | &nbsp; Forecasted:&nbsp;
                    <span className='category-value'>
                        {Math.round(category.Forecasted).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                    </span>  &nbsp;
                    | &nbsp; Actuals:&nbsp;
                    <span className={category.Spent ? (Math.round(category.Spent) > Math.round(category.Forecasted) ? 'category-value-red' : 'category-value-green') : 'category-value'}>

                        {Math.round(category.Spent).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}

                        {category.Spent ?
                            <>
                                {Math.round(category.Spent) > Math.round(category.Forecasted) ? <span className='category-value-red'>
                                    &nbsp;({percent(category.Spent, category.Forecasted)}%)</span> :
                                    <span className='category-value-green'>
                                        &nbsp;({percent(category.Spent, category.Forecasted)}%)</span>}

                            </>

                            : null}
                    </span>
                </div>
                <div className='category-card-button'>
                    <CategoryButton />
                </div>
            </div>
        </div>
    )
}

export default CategoryCard